import { useEffect, useState, useCallback, useRef } from 'react'
import API from '../../../api'

export default function useAdventureReviews(diveCenterId) {
  const [pages, setPages] = useState([])
  const [count, setCount] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [loading, setLoading] = useState(false)
  const pageRef = useRef(1)
  const loadingRef = useRef(false)
  const controllerRef = useRef(null)

  useEffect(() => {
    if(!diveCenterId) { return }

    if(controllerRef.current) { controllerRef.current.abort() }
    const controller = 'AbortController' in window ? new window.AbortController() : null
    controllerRef.current = controller

    pageRef.current = 1
    setPages([])
    setCount(0)
    setHasMore(false)
    loadingRef.current = true
    setLoading(true)

    API(`/api/adventure/v1/${diveCenterId}/reviews/`, controller?.signal)
      .get({ page: 1 })
      .then((data) => {
        if(controller?.signal.aborted) { return }
        setPages([data?.results || []])
        setCount(data?.count || 0)
        setHasMore(!!data?.next)
      })
      .catch((error) => {
        if(error?.name !== 'AbortError') { console.error('useAdventureReviews fetch failed', error) }
      })
      .finally(() => {
        if(controller?.signal.aborted) { return }
        loadingRef.current = false
        setLoading(false)
      })

    return () => { controller?.abort() }
  }, [diveCenterId])

  const loadMore = useCallback(() => {
    if(loadingRef.current || !hasMore || !diveCenterId) { return }
    loadingRef.current = true
    setLoading(true)
    const nextPage = pageRef.current + 1
    const controller = controllerRef.current
    API(`/api/adventure/v1/${diveCenterId}/reviews/`, controller?.signal)
      .get({ page: nextPage })
      .then((data) => {
        if(controller?.signal.aborted) { return }
        setPages((prev) => [...prev, data?.results || []])
        setHasMore(!!data?.next)
        pageRef.current = nextPage
      })
      .catch((error) => {
        if(error?.name !== 'AbortError') { console.error('useAdventureReviews fetch failed', error) }
      })
      .finally(() => {
        if(controller?.signal.aborted) { return }
        loadingRef.current = false
        setLoading(false)
      })
  }, [diveCenterId, hasMore])

  return { pages, count, hasMore, loadMore, loading }
}
